import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminIndexing from "@/pages/admin/AdminIndexing";

export const Route = createFileRoute("/admin/indexing")({
  head: () => pageHead("Admin \u2014 Indexing \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminIndexing,
});
